var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6001 14.2668C7.6001 14.4877 7.77918 14.6668 8.0001 14.6668C8.22101 14.6668 8.4001 14.4877 8.4001 14.2668V8.4001H14.2668C14.4877 8.4001 14.6668 8.22101 14.6668 8.0001C14.6668 7.77918 14.4877 7.6001 14.2668 7.6001H8.4001V1.7335C8.4001 1.51258 8.22101 1.3335 8.0001 1.3335C7.77918 1.3335 7.6001 1.51258 7.6001 1.7335V7.6001H1.7335C1.51258 7.6001 1.3335 7.77918 1.3335 8.0001C1.3335 8.22101 1.51258 8.4001 1.7335 8.4001H7.6001V14.2668Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.623dca2d5fd84c59433b52144a38da42.svg";
export { ForwardRef as ReactComponent };